import React from 'react';
import { INotificationsContext } from '../models/INotificationsContext';

export const NotificationsContext = React.createContext<INotificationsContext>({
  legacyNotifications: [],
  setLegacyNotifications: () => {},
  notificationConfig: {
    user: null,
    apiToken: '',
    coreApiToken: '',
    graphToken: '',
    userEmail: '',
    notificationApiUrl: '',
    dismissApiUrl: '',
  },
  setNotificationConfig: () => {},
});
